<template>
  <v-card>
    <v-card-title>แจ้งเตือนรายการยาและเวชภัณฑ์<v-spacer/></v-card-title>
    <v-card-text>
    <v-data-table :headers="headers" :items="items" dense>
    <template v-slot:item.suggest_display="{ item }">
      <span>{{ item.suggest_display || item.reason_name || '—' }}</span>
     </template>
    </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: {
    items: {
      type: Array
    }
  },
  computed: {
    ...mapState('User', ['group'])
  },
  data () {
    return {
      headers: [
        { text: 'รหัสยาและเวชภัณฑ์', value: 'Matcode' },
        { text: 'ชื่อรายการ', value: 'Matdesc' },
        { text: 'คำแนะนำ', value: 'suggest_display' }
      ],
    }
  },
}
</script>

<style>

</style>